/** @jsxImportSource @emotion/react */
import { Container, Divider, Section } from 'components/landing/ui';

import GuaranteedResult from '../../ui/guaranteed-result';
import LeftCol from './left-col';
import RightCol from './right-col';

const S3 = ({ openVideo }) => (
  <Container>
    <Section
      css={{
        paddingTop: 50,
        '@media (min-width:992px)': { paddingTop: 100 },
        '@media (min-width:1366px)': { paddingTop: 120 },
      }}
    >
      <div
        css={{
          alignItems: 'center',
          '>div:nth-of-type(1)': {
            flexBasis: '38%',
            flexShrink: 1,
            marginBottom: 30,
            '@media (min-width:992px)': { marginRight: 50, marginBottom: 0 },
          },
          '>div:nth-of-type(2)': {
            flexBasis: '62%',
            flexShrink: 1,
          },
          '@media (min-width:992px)': {
            flexDirection: 'row',
            paddingBottom: 40,
            alignItems: 'flex-start',
          },
          flexDirection: 'column',
          paddingBottom: 30,
          zIndex: 2,
          width: '100%',
        }}
      >
        <LeftCol />

        <RightCol openVideo={openVideo} />
      </div>

      <GuaranteedResult>
        ВКБОСС будет делать делать действия, на которые вы не захотите тратить своё время.
      </GuaranteedResult>

      <Divider
        css={{
          marginTop: 50,
          '@media (min-width:992px)': { marginTop: 100 },
          '@media (min-width:1366px)': { marginTop: 120 },
        }}
      />
    </Section>
  </Container>
);

export default S3;
